'use client'

import { useTranslation } from 'react-i18next'
import { useLanguageStore } from '../lib/store'
import { useEffect, useCallback } from 'react'

// RTL languages list
const RTL_LANGUAGES = ['he', 'ar', 'fa']

export function useI18n() {
  const { t, i18n } = useTranslation()
  const { currentLanguage, setLanguage } = useLanguageStore()
  
  // Check if current language is RTL
  const isRtl = RTL_LANGUAGES.includes(currentLanguage)
  
  // Sync i18n language with store when currentLanguage changes
  // CRITICAL: Only depend on currentLanguage, NOT on i18n object
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage]) // eslint-disable-line react-hooks/exhaustive-deps
  
  const changeLanguage = useCallback((locale: 'en' | 'es' | 'he') => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem('snapland-user-chose-language', '1')
      }
    } catch {
      // ignore
    }
    setLanguage(locale)
    i18n.changeLanguage(locale)
  }, [setLanguage]) // eslint-disable-line react-hooks/exhaustive-deps
  
  // Type assertion to allow any translation key
  const typedT = t as (key: string, options?: any) => string;
  
  return { 
    t: typedT, 
    i18n,
    isLoading: false,
    changeLanguage,
    currentLanguage,
    isRtl
  }
}
